import _ from 'underscore';

export default function ExamplesService($http, $q, DataService) {
  const vm = this;

  vm.deleteExample = deleteExample;
  vm.examples = [];
  vm.getExamples = getExamples;
  vm.newFromCreative = newFromCreative;
  vm.newFromDemo = newFromDemo;
  vm.newFromVariant = newFromVariant;
  vm.saveExamples = saveExamples;
  vm.saveExample = saveExample;

  let newExampleId = -1;

  return vm;

  function prepareCreative(creative) {
    return creative;
  }

  function prepareCreativeForCreation(creative) {
    if (creative.slides) {
      creative.slides_attributes = creative.slides;
    }

    return prepareCreative(creative);
  }

  function saveExamples() {
    return $http.put('/examples', { examples: vm.examples });
  }

  function saveExample(example) {
    return $http.post('/examples', { example });
  }

  function newFromDemo(demoId) {
    return DataService.getCreative(demoId).then(({ data }) => {
      return newFromCreative(data);
    });
  }

  function newFromCreative(creativeData) {
    const creative = prepareCreativeForCreation(creativeData);
    return DataService.createArchivedPreview(creative).then(({ data }) => {
      const creative = prepareCreative(data);

      const example = {
        id: newExampleId--,
        name: creative.name,
        action: creative.action,
        demoId: creative.id,
        creative
      };

      vm.examples.unshift(example);
      return vm.examples;
    });
  }

  function newFromVariant(variant) {
    return DataService.createExampleFromVariant(variant).then(({ data }) => {
      let creative = prepareCreative(data);

      let example = {
        id: newExampleId--,
        name: creative.name,
        action: creative.action,
        demoId: creative.id,
        creative
      };

      return vm.examples.unshift(example);
    });
  }

  function deleteExample(id) {
    vm.examples = _.reject(vm.examples, example => example.id === id);
  }

  function getExamples() {
    return $q.resolve().then(() => {
      if (vm.examples.length > 0) {
        return vm.examples;
      }

      return $http.get('/examples').then(({ data }) => {
        vm.examples = data.map(example => ({
          action: example.action,
          demoId: example.demoId,
          description: example.description,
          id: example.id,
          name: example.name,
          creative: prepareCreative(example.creativePreview)
        }));

        return vm.examples;
      });
    });
  }
}

ExamplesService.$inject = ['$http', '$q', 'DataService'];
